import script from "./AboutTeam.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutTeam.vue?vue&type=script&setup=true&lang=js"

import "./AboutTeam.vue?vue&type=style&index=0&id=7f482fb2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f482fb2"]])

export default __exports__